import Model from '../utils/Model'
import CommonState from '@/class/cargo/model/parameters/CommonState'

export const CODE_NAME = 'TruckingInfoPrintState'

export const NOT_PRINT_TYPE = new CommonState(0, '未打印', 'notPrint')
export const PRINTED_TYPE = new CommonState(1, '已打印', 'printed')
export const CUSTOMER_PRINT_TYPE = new CommonState(2, '客户自己已打印', 'cutomerPrint')// Co Loader

export const TRUCKINGINFO_PRINT_STATES = [NOT_PRINT_TYPE, PRINTED_TYPE, CUSTOMER_PRINT_TYPE]
/**
		 *  return null:没找到.
		 */
export function getTruckingInfoPrintStateByCode(code) {
  return Model.getObjByCode(code, TRUCKINGINFO_PRINT_STATES)
}

/**
		 *  return null:没找到.
		 */
export function getTruckingInfoPrintStateNameByCode(code, arrs) {
  return Model.getObjByCode(code, arrs)
}

